import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { useI18n } from '@/contexts/I18nContext';

const MONTH_KEYS = [
  'months.jan', 'months.feb', 'months.mar', 'months.apr', 'months.may', 'months.jun',
  'months.jul', 'months.aug', 'months.sep', 'months.oct', 'months.nov', 'months.dec'
];

const MonthPicker = ({ value, onChange, onClose }) => {
  const { t } = useI18n();
  const [year, month] = (value || '').split('-').map(Number);
  const [viewYear, setViewYear] = useState(year || new Date().getFullYear());

  const handleSelect = (m) => {
    onChange(`${viewYear}-${String(m + 1).padStart(2, '0')}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-card border border-border rounded-t-2xl sm:rounded-xl p-5 w-full max-w-sm" onClick={e => e.stopPropagation()} data-testid="month-picker-modal">
        <div className="flex items-center justify-between mb-4">
          <button onClick={() => setViewYear(y => y - 1)} className="p-2 hover:bg-card-hover rounded-lg">
            <ChevronLeft size={18} />
          </button>
          <span className="font-semibold text-lg">{viewYear}</span>
          <button onClick={() => setViewYear(y => y + 1)} className="p-2 hover:bg-card-hover rounded-lg">
            <ChevronRight size={18} />
          </button>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {MONTH_KEYS.map((key, i) => {
            const isSelected = viewYear === year && i === month - 1;
            return (
              <button
                key={i}
                onClick={() => handleSelect(i)}
                className={`py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isSelected
                    ? 'bg-accent text-background'
                    : 'hover:bg-card-hover text-foreground-secondary'
                }`}
                data-testid={`month-option-${i + 1}`}
              >
                {t(key)}
              </button>
            );
          })}
        </div>
        <button onClick={onClose} className="w-full mt-4 btn btn-secondary text-sm py-2" data-testid="month-picker-close">
          {t('common.close')}
        </button>
      </div>
    </div>
  );
};

export default MonthPicker;
